import ColumnDefinition from '../ColumnDefinition.js';

export default {
    defaultSort: { field: 'created_at', direction: 'desc' },
    columns: [
        new ColumnDefinition('file_name', window.i18n.__('Nom du fichier'), false, false),
        new ColumnDefinition('created_at', window.i18n.__("Date d'import"), false, true, function (date) {
            return window.sellsyapp.config.globalProperties.$filters.dateFormatter(
                date,
                'SLASHED_DATE_TIME',
            );
        }),
        new ColumnDefinition('state', window.i18n.__('Statut du traitement'), false, false, function (
            state,
            row,
        ) {
            return {
                type: 'component',
                name: 'ocr-item-state',
                params: {
                    state,
                    id: row.id,
                    errorCode: row.error_code,
                },
            };
        }),
        new ColumnDefinition(
            'id',
            '',
            false,
            false,
            function (id) {
                return {
                    type: 'component',
                    name: 'ocr-item-list-action',
                    params: {
                        id: id,
                        canVerifOcr: this.metas.user_can_validate_pur_invoice,
                    },
                };
            },
            {
                width: 'L',
                alignment: 'center',
            },
        ),
    ],
    filters: [],
    hooks: {
        metas: function (metas) {
            return metas;
        },
        fetch: function (data) {
            data.filters.state = ['completed', 'error', 'pending', 'processing'];
        },
    },
    contextMenus: [],
    batchActions: [],
};
